import { render, staticRenderFns } from "./ManageProjects.vue?vue&type=template&id=50262450&scoped=true&"
import script from "./ManageProjects.vue?vue&type=script&lang=js&"
export * from "./ManageProjects.vue?vue&type=script&lang=js&"
import style0 from "./ManageProjects.vue?vue&type=style&index=0&id=50262450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50262450",
  null
  
)

export default component.exports